module.exports = __webpack_public_path__ + "static/img/logo15.9672182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo15.png
// module id = bmDR
// module chunks = 1